module.exports = __webpack_public_path__ + "img/guali.d479af1e.jpg";